module.exports = __webpack_public_path__ + "static/media/poly42.2d9ddd70.jpg";